import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'

const CycleTime: React.FC = () => {
  return (
    <HeaderWidget
      title='Cycle Time'
      information='This metric measures the total time it takes to complete a task from start to finish.'
    >
      -
    </HeaderWidget>
  )
}

export default CycleTime
